/**
 * @generated SignedSource<<6eb3ad9a83f3706bb3b9c1d9bd137d4a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type UpdateGeneralAssetManufacturerInput = {
  generalAssetManufacturerId: string;
  updateGeneralAssetManufacturerData: UpdateGeneralAssetManufacturerData;
  clientMutationId?: string | null;
};
export type UpdateGeneralAssetManufacturerData = {
  name?: string | null;
};
export type updatePageUpdateGeneralAssetManufacturerMutation$variables = {
  input: UpdateGeneralAssetManufacturerInput;
};
export type updatePageUpdateGeneralAssetManufacturerMutationVariables = updatePageUpdateGeneralAssetManufacturerMutation$variables;
export type updatePageUpdateGeneralAssetManufacturerMutation$data = {
  readonly updateGeneralAssetManufacturer: {
    readonly generalAssetManufacturer: {
      readonly id: string;
      readonly createdAt: any;
      readonly name: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly fields: ReadonlyArray<{
        readonly fieldName: string;
        readonly message: string;
      }> | null;
    }>;
  } | null;
};
export type updatePageUpdateGeneralAssetManufacturerMutationResponse = updatePageUpdateGeneralAssetManufacturerMutation$data;
export type updatePageUpdateGeneralAssetManufacturerMutation = {
  variables: updatePageUpdateGeneralAssetManufacturerMutationVariables;
  response: updatePageUpdateGeneralAssetManufacturerMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateGeneralAssetManufacturerPayload",
    "kind": "LinkedField",
    "name": "updateGeneralAssetManufacturer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GeneralAssetManufacturer",
        "kind": "LinkedField",
        "name": "generalAssetManufacturer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserFieldError",
            "kind": "LinkedField",
            "name": "fields",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fieldName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updatePageUpdateGeneralAssetManufacturerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updatePageUpdateGeneralAssetManufacturerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b48d52befee7d6f9f583131e50047e29",
    "id": null,
    "metadata": {},
    "name": "updatePageUpdateGeneralAssetManufacturerMutation",
    "operationKind": "mutation",
    "text": "mutation updatePageUpdateGeneralAssetManufacturerMutation(\n  $input: UpdateGeneralAssetManufacturerInput!\n) {\n  updateGeneralAssetManufacturer(input: $input) {\n    generalAssetManufacturer {\n      id\n      createdAt\n      name\n    }\n    errors {\n      code\n      fields {\n        fieldName\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b1aeb1c8145340a4478886b0aedbc026";

export default node;
